import SearchToolsTabs from '@/components/admin/SearchToolsTabs';
import {
  Main,
  UsersGrid,
  UsersTableSection,
} from '@/components/admin/user/components';
import RWAdminsTable from '@/components/admin/user/RWAdminsTable';
import SearchBar from '@/components/admin/user/SearchBar';
import { Box, Container } from '@mui/material';
import React from 'react';

const RWAdmins = () => {
  return (
    <Main>
      <UsersGrid>
        <Box />
        <SearchToolsTabs />
      </UsersGrid>
      <SearchBar />

      <UsersTableSection>
        <Container maxWidth="xl" sx={{ width: '95%' }}>
          <RWAdminsTable />
        </Container>
      </UsersTableSection>
    </Main>
  );
};

export default RWAdmins;
